import { ClientEnvironmentListResponse, ClientEnvironmentDTO } from '../infrastructure/models';
import ApiService from './ApiService';

export const fetchAllClientEnvironments = async (
  tenantId: string,
  offset = 0,
  limit = 10,
  signal?: AbortSignal,
): Promise<ClientEnvironmentListResponse> => {
  const response = await ApiService.get<ClientEnvironmentListResponse>({
    url: `tenants/${tenantId}/environments?offset=${offset}&limit=${limit}`,
    signal,
  });
  return response;
};

export const createClientEnvironment = async (
  tenantId: string,
  payload: { name: string; description: string },
  signal?: AbortSignal,
): Promise<ClientEnvironmentDTO> => {
  const response = await ApiService.post<ClientEnvironmentDTO>({
    url: `tenants/${tenantId}/environments`,
    data: payload,
    signal,
  });
  return response;
};

export const editClientEnvironment = async (
  tenantId: string,
  environmentId: string,
  payload: { name: string; description: string },
  signal?: AbortSignal,
): Promise<ClientEnvironmentDTO> => {
  const response = await ApiService.patch<ClientEnvironmentDTO>({
    url: `tenants/${tenantId}/environments/${environmentId}`,
    data: payload,
    signal,
  });
  return response;
};

export const deleteClientEnvironment = async (
  tenantId: string,
  environmentId: string,
  signal?: AbortSignal,
): Promise<void> => {
  await ApiService.delete({
    url: `tenants/${tenantId}/environments/${environmentId}`,
    signal,
  });
};
